import axios from "axios";
import { HR7_IS_CLOUD, domain, getDatabase, getSentryDatabase } from "../components/Security";

const apiClient = axios.create({
  baseURL: domain,
});

// 🔐 SAFE INTERCEPTOR (DOES NOT OVERRIDE HEADERS)
apiClient.interceptors.request.use(
  async (config) => {
    config.headers = config.headers || {};

    // ✅ DO NOT override Authorization
    // (your fetch files still define it)
    
    // 🗄️ Inject database selected at login
    const database = getDatabase();
    const biometricsDatabase = getSentryDatabase(); 
    /**
     * -------------------------------------------------------------------------------------
     * --------------Fix this---------------
     * -------------------------------------------------------------------------------------
     * 
     */
    

    // if (database && !config.headers["X-Database-Name"]) {
    //   config.headers["X-Database-Name"] = database;
    // }

    if (
      HR7_IS_CLOUD &&
      database &&
      config.url?.startsWith(domain)
    ) {
      config.headers["X-Database-Name"] = database;
      config.headers["X-Biometrics-Database-Name"] = biometricsDatabase;
      // console.warn("=========================================================================================================")
      // console.warn("Fix the Biometrics connection. need function from subscription Portal for Biometrics DB Name")
      // console.warn("=========================================================================================================")
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
